module.exports = __webpack_public_path__ + "static/media/Inter-ExtraLight.d0f08c55.ttf";